export const destination = {
  imageUrl: "whereToGo/listing1.jpg",
  title: `Kumbalangi Tourism village, Kochi`,
  description: `Lorem Ipsum is simply dummy text of the printing and 
  typesetting industry. Lorem Ipsum has been the 
  industry's standard dummy text ever since the 1500s, 
  when an unknown printer took a galley of type and 
  scrambled it to make a type specimen book. 
  It has survived not only five centuries.`,
  subExploreItems: [
    {
      imageUrl: 'whereToGo/tourGuideBG.jpg',
      title: 'Hills'
    },
    {
      imageUrl: 'whereToGo/tourGuideBG.jpg',
      title: 'Beach'
    }
  ]
};

export const ecotourism = {
  imageUrl: "whereToGo/listing1.jpg",
  title: `Kumbalangi Tourism village, Kochi`,
  description: `Lorem Ipsum is simply dummy text of the printing and 
  typesetting industry. Lorem Ipsum has been the 
  industry's standard dummy text ever since the 1500s, 
  when an unknown printer took a galley of type and 
  scrambled it to make a type specimen book. 
  It has survived not only five centuries.`,
}

export const placesOfInterest = {
  imageUrl: "whereToGo/listing1.jpg",
  title: `Kumbalangi Tourism village, Kochi`,
  description: `Lorem Ipsum is simply dummy text of the printing and 
  typesetting industry. Lorem Ipsum has been the 
  industry's standard dummy text ever since the 1500s, 
  when an unknown printer took a galley of type and 
  scrambled it to make a type specimen book. 
  It has survived not only five centuries.`,
  subExploreItems: [
    {
      imageUrl: 'whereToGo/tourGuideBG.jpg',
      title: 'Hills'
    },
    {
      imageUrl: 'whereToGo/tourGuideBG.jpg',
      title: 'Beach'
    }
  ]
};

export const photoGallery = [
  {
    title: 'Drive in beaches in kerala',
    imageUrl: 'whereToGo/listing1.jpg',
  },
  {
    title: 'Drive in beaches in kerala',
    imageUrl: 'whereToGo/listing1.jpg',
  },
  {
    title: 'Drive in beaches in kerala',
    imageUrl: 'whereToGo/listing1.jpg',
  },
  {
    title: 'Drive in beaches in kerala',
    imageUrl: 'whereToGo/listing1.jpg',
  },
];
